var exports = module.exports = {};
var env = require('../utils/env');
var request = require('superagent');
var USER_INFO = "userinfo";
var checkedServerAuth = false;
exports.login = function(loginObj, callback) {
  loginObj.environment = 'INTERNAL';
  request
  .post(env.domain.api + '/auth/local')
  .send(loginObj)
  .withCredentials()
  .then(function(response) {

    // console.log("body is ",response.body);
    // exports.setCurrentUser(response.body);
    // return callback(null,response.body);//null, response.body);
    exports.getUserInfo(function(err, user) {
      if (user) {
        exports.setCurrentUser(user);
        return callback(null, user);
      }
      return callback(err);
    },loginObj);


  }, function(err) {
    var ERR = err.response.body;
    return callback(ERR);
  })
}

exports.getUserInfo = function(callback,loginObj) {

  // return callback(null,exports.getCurrentUser());
  var currentUserEmail = null;
  if (loginObj!=null) { currentUserEmail = loginObj["username"];console.log("1 ",loginObj); }
  else { 
    var lObj = exports.getCurrentUser();

    if (lObj!=null) {
      currentUserEmail = lObj["email"];
    }
    console.log("2 ",lObj);
    // currentUserEmail = lObj["email"];
    console.log("2 "); 
  }

  if (currentUserEmail==null) {

    try {
      
      var cachedUser = JSON.parse(localStorage.getItem("userinfo"));
      // currentUserEmail = cachedUser["email"];
      if (cachedUser!=null) {
        currentUserEmail = cachedUser["email"];
      }

    } catch (error) {
      console.log(error);
    }
  }

  if (currentUserEmail!=null) {
  
    request
    // .post(env.domain.api + '/v1/userinfo')
    .get(env.domain.api + '/v1/teacheruserinfo?username='+currentUserEmail)
    // .send(loginObj)
    // .withCredentials()
    .then(function(response) {
      console.log("response is " + JSON.stringify(response));
      exports.setCurrentUser(response.body);
      // return callback;
      return callback(null, response.body);
    }, function(err) {
      var ERR = err.response.body || err.response.text;
      return callback(ERR);
    })
  } else {

    return callback("Login required");
  }
}

// exports.currentUser = null;

exports.hasLoggedIn = function(callback) {
  callback = callback || function(){};
  var cachedUser;
  try {
    cachedUser = JSON.parse(localStorage.getItem("userinfo"));//JSON.parse(localStorage.getItem(USER_INFO, null));
    exports.setCurrentUser(cachedUser);
  } catch(err) {
    cachedUser = null;
  }
  if (checkedServerAuth && cachedUser) return callback(null, cachedUser);
  if (checkedServerAuth) return callback('NOT_LOGGED_IN');
  exports.getUserInfo(function(err, user) {
    checkedServerAuth = true;
    exports.setCurrentUser(user);
    callback(err, user);
  })
}

exports.getCurrentUser = function() {
  var cachedUser = null;
  try {
    cachedUser = JSON.parse(localStorage.getItem(USER_INFO));  
  }
  catch(e) {

  }
  return exports.currentUser || cachedUser;
}

exports.setCurrentUser = function(user) {
  localStorage.setItem(USER_INFO, JSON.stringify(user));
  exports.currentUser = user;
}

exports.logout = function(callback) {
  callback = callback || function(){};
  request
  .delete(env.domain.api + "/auth/logout")
  .withCredentials()
  .then(function(response) {
    localStorage.setItem(USER_INFO, null);
    return callback(null, 'SUCCESS');
  }, function(err) {
    return callback('ERR');
  })
}

exports.changePassword = function(data, callback) {
  callback = callback || function(){};
  request
  .put(env.domain.api + '/v1/userinfo/password')
  .send(data)
  .withCredentials()
  .then(function(response) {
    callback(null, response);
  }, function(err) {
    callback(err);
  })
}


/** WEBPACK FOOTER **
 ** ./src/resources/auth.js
 **/